module.exports = __webpack_public_path__ + "static/media/div1guldjakt.b0bbbaff.jpeg";